import { Component, inject, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Betriebsdaten } from '../../../domain/model/betriebsdaten.model';
import { FormGroupConfig } from '../form-config.model';
import { AbstractForm } from '../abstract-form.model';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { Feld } from '../../../domain/model/feld.enum';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';

@Component({
    selector: 'redispatch-betrieb-sub-form',
    templateUrl: './betrieb-sub-form.component.html',
    styleUrls: [
        './betrieb-sub-form.component.scss',
    ],
    standalone: false,
})
export class BetriebSubFormComponent extends AbstractForm<Betriebsdaten> {

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;
    public readonly Feld = Feld;

    @Input({ required: true }) disabled: boolean;
    @Input({ required: true }) readonly: boolean;

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<Betriebsdaten> {
        return {
            erstmaligerInbetriebnahmezeitpunkt: [
                { value: null, disabled: this.readonly || this.disabled },
                [
                    MatValidators.required,
                ],
            ],
            kommerziellerInbetriebnahmezeitpunkt: [
                { value: null, disabled: this.readonly || this.disabled },
            ],
            stilllegungszeitpunktVorlaeufig: [
                { value: null, disabled: this.readonly || this.disabled },
            ],
            stilllegungszeitpunktEndgueltig: [
                { value: null, disabled: this.readonly || this.disabled },
            ],
        };
    }

    public sanitize(betriebsdaten: Betriebsdaten): Betriebsdaten {
        return betriebsdaten;
    }

}
